export const RootErrorFallback = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '1rem',
      fontFamily: 'sans-serif',
    }}
  >
    <h1>Something went wrong</h1>
    <p>An unexpected error occurred. Please refresh the page.</p>
    <button
      onClick={() => {
        window.location.reload();
      }}
    >
      Refresh
    </button>
  </div>
);
